import React from "react";
import "./social-component.scss";

class SocialComponent extends React.Component {
  handleShare = (network) => {
    const url = encodeURIComponent("https://racker2racker.givinga.app/");
    const title = encodeURIComponent("Support Racker2Racker - Employee Assistance Program");
    const text = encodeURIComponent("Help support fellow Rackers facing financial hardships through the Racker2Racker employee assistance program.");
    
    let shareUrl = "";
    
    switch(network) {
      case "facebook":
        shareUrl = `https://www.facebook.com/sharer/sharer.php?u=${url}`;
        break;
      case "twitter":
        shareUrl = `https://twitter.com/intent/tweet?url=${url}&text=${text}`;
        break;
      case "linkedin":
        shareUrl = `https://www.linkedin.com/sharing/share-offsite/?url=${url}`;
        break;
      case "email":
        shareUrl = `mailto:?subject=${title}&body=${text}%20${url}`;
        break;
      default:
        return;
    }
    
    if (network === "email") {
      window.location.href = shareUrl;
    } else {
      window.open(shareUrl, "_blank", "width=600,height=400");
    }
  };

  render() {
    return (
      <div className="social-container">
        <div className="row">
          <div className="social-container-icons">
            <center>
              <div className="social-container-icons st-custom-button">
                <button
                  className="st-custom-button"
                  onClick={() => this.handleShare("facebook")}
                  style={{ background: "none", border: "none", cursor: "pointer" }}
                  aria-label="Share on Facebook"
                >
                  <img src={require("../images/social/facebook.png")} alt="Facebook" />
                </button>
                <button
                  className="st-custom-button"
                  onClick={() => this.handleShare("twitter")}
                  style={{ background: "none", border: "none", cursor: "pointer" }}
                  aria-label="Share on Twitter"
                >
                  <img src={require("../images/social/x.png")} alt="X" style={{ transform: "scale(1.15)" }} />
                </button>
                <button
                  className="st-custom-button"
                  onClick={() => this.handleShare("linkedin")}
                  style={{ background: "none", border: "none", cursor: "pointer" }}
                  aria-label="Share on LinkedIn"
                >
                  <img src={require("../images/social/linkedin.png")} alt="LinkedIn" />
                </button>
                <button
                  className="st-custom-button"
                  onClick={() => this.handleShare("email")}
                  style={{ background: "none", border: "none", cursor: "pointer" }}
                  aria-label="Share via Email"
                >
                  <img src={require("../images/social/email.png")} alt="Email" />
                </button>
              </div>
            </center>
          </div>
        </div>
      </div>
    );
  }
}

export default SocialComponent;